export enum SupportChannelAPIKeys {
  chat = "chatPermission",
  phone = "phonePermission",
  email = "emailPermission",
  consultation = "consultation"
}
